import { Typography } from '@mui/material'
import { Lock } from 'mdi-material-ui'
import dynamic from 'next/dynamic'
import React, { useState } from 'react'
import { useUser } from 'src/lib/contexts/UserContext'
import { permissionType } from 'src/lib/utils/constants'

interface PreviewCTAProps {
  color: string
  textColor: string
  CTAHeight?: number
  CTAWidth?: number | string
  CTAText: string
  isSecuredByTextEnabled: boolean
  isAnchored: boolean
  marketingConsentText?: string
}

const PreviewCTA: React.FC<PreviewCTAProps> = ({
  color,
  textColor,
  CTAHeight = 56,
  CTAWidth = '100%',
  CTAText,
  isSecuredByTextEnabled,
  isAnchored,
  marketingConsentText
}) => {
  const { canAccess } = useUser()
  const canViewMarketingFlag = canAccess(permissionType.MARKETING_FLAG, 0)

  return (
    <div
      style={{
        ...(isAnchored
          ? {
              position: 'absolute',
              bottom: 0,
              left: 0
            }
          : {}),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 12,
        padding: '0.875rem',
        width: '100%',
        marginBottom: 10
      }}
    >
      <div
        style={{
          background: color,
          borderRadius: '16px',
          height: CTAHeight,
          width: CTAWidth,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Typography variant='body1' sx={{ fontWeight: 600, color: textColor }}>
          {CTAText}
        </Typography>
      </div>
      {canViewMarketingFlag && marketingConsentText && (
        <div className='flex h-12 w-full flex-row items-center justify-center space-x-2 px-6 xxs:px-4 pt-7 pb-4'>
          <input
            type='checkbox'
            id='marketing_user_consent_preview'
            name='marketing_user_consent_preview'
            className='h-3.5 w-3.5 cursor-pointer rounded-sm accent-coal-dark'
            checked={true}
            readOnly
          />
          <label
            htmlFor='marketing_user_consent_preview'
            className='select-none text-xs font-normal text-coal-light cursor-pointer'
          >
            <p dangerouslySetInnerHTML={{ __html: marketingConsentText }} />
          </label>
        </div>
      )}
      {isSecuredByTextEnabled ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 2
          }}
        >
          <Lock sx={{ height: 12, width: 12, marginBottom: 0.5 }} />
          <Typography sx={{ fontSize: 10 }}>Secured by </Typography>
          <img src={'/images/flo-full-logo-mono.svg'} style={{ height: '11px' }} alt={'shopflo-logo'} />
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}

export default PreviewCTA
